import React, { useState } from "react";
import './Footer.css'; 
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import sprout from '../assets/sprout_white.png'




const Footer = () => {
 

  const sendEmail = (e) => {
    e.preventDefault();
  
    const formData = new FormData(e.target);
    const data = {
      from_firstname: formData.get("from_firstname"),
      from_lastname: formData.get("from_lastname"),
      from_phonenumber: formData.get("from_phonenumber"),
      country: formData.get("country"),
      from_emailid: formData.get("from_emailid"),
      organization: formData.get("organization"),
      message: formData.get("message"),
    };
  
    console.log("Data being sent:", data);
  
    emailjs
      .send("service_nxepswl", "template_jumzlyr", data, "Ei4GRgZo9kOlQvyW9")
      .then((response) => {
        console.log("Email sent successfully", response);
        alert("Your message has been sent successfully!");
      })
      .catch((error) => {
        console.error("Email sending failed", error);
        alert("Sorry, something went wrong. Please try again later.");
      });
  };
  
  const [isOpen, setIsOpen] = useState(false);
  
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      await sendEmail(event);
      togglePopup();
    } catch (error) {
      console.error("Error submitting the form:", error);
    }
  };
 

  return (
    <footer className="footer-ecoindex">
      <div className="footer-ecoindex-top">
     
        
        <div className="footer-ecoindex-links">
          <a href="/">Home</a>
          <a href="/aboutecoindex"  target="_blank">
                  About Us
                </a>
                <a href="/Resources" target="_blank">
                  Resources
                </a>
        </div>
        <div className="social-icons">
          <a href="https:/x.com/Ecoindex_ai" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
          <a href="https://www.linkedin.com/company/ecoindex" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
          <a href="https://www.instagram.com/ecoindex_ai/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        

        </div>
      </div>
      
      <div className="footer-ecoindex-bottom">
        <div className="footer-ecoindex-nav">
        <a
                  href="/terms_and_conditions"
              
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>
        <a
                  href="/privacy_policy"
                  
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
          <a onClick={togglePopup}>Contact</a>
                      
{isOpen && (
                <div className="popup">
                  <div className="popup-content">
                    <span className="close-icon" onClick={togglePopup}>
                      &times;
                    </span>
                    <h2 className="popup-title">
                      Schedule a Call <i class="fa fa-phone"></i>
                    </h2>

                    <form className="popup-form" onSubmit={handleFormSubmit}>
                      <div className="input-row">
                        <div className="input-group half-width">
                          <label>First Name</label>
                          <input type="text" name="from_firstname" required />
                        </div>
                        <div className="input-group half-width">
                          <label>Last Name</label>
                          <input type="text" name="from_lastname" required />
                        </div>
                      </div>

                      <div className="input-row">
                        <div className="input-group half-width">
                          <label>Phone No.</label>
                          <input type="tel" name="from_phonenumber" required />
                        </div>
                        <div className="input-group half-width">
                          <label>Country</label>
                          <input type="text" name="country" required />
                        </div>
                      </div>

                      <div className="input-group">
                        <label>Email</label>
                        <input type="email" name="from_emailid" required />
                      </div>

                      <div className="input-group">
                        <label>Organization</label>
                        <input type="text" name="organization" required />
                      </div>

                      <div className="input-group">
                        <label>What do you want to know?</label>
                        <textarea name="message" required></textarea>
                      </div>

                      <div className="popup-buttons">
                        <button type="submit" className="submit-button">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
        </div>
        
        <h1 className="footer-title"> <span><img src={sprout} alt="logo" /></span></h1>
        <div className="footer-ecoindex-brand">
         
          <span>Ecoindex © {new Date().getFullYear()}. All Rights Reserved.</span>
        </div>
      </div>
    
    </footer>
  );
};

export default Footer;